export const AiSparkleSvg = ({ color = "currentColor" } = {}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8 1.25l.72 2.55a2.5 2.5 0 0 0 1.73 1.73L13 6.25l-2.55.72a2.5 2.5 0 0 0-1.73 1.73L8 11.25l-.72-2.55a2.5 2.5 0 0 0-1.73-1.73L3 6.25l2.55-.72a2.5 2.5 0 0 0 1.73-1.73L8 1.25z"
      fill={color}
    />
    <path
      d="M12.5 9.5l.36 1.27a1.25 1.25 0 0 0 .87.87L15 12l-1.27.36a1.25 1.25 0 0 0-.87.87L12.5 14.5l-.36-1.27a1.25 1.25 0 0 0-.87-.87L10 12l1.27-.36a1.25 1.25 0 0 0 .87-.87L12.5 9.5z"
      fill={color}
    />
    <path
      d="M3.25 10.25l.28.98c.1.35.37.62.72.72l.98.28-.98.28a1 1 0 0 0-.72.72l-.28.98-.28-.98a1 1 0 0 0-.72-.72l-.98-.28.98-.28a1 1 0 0 0 .72-.72l.28-.98z"
      fill={color}
    />
  </svg>
);
